import { render, staticRenderFns } from "./policy-form.vue?vue&type=template&id=c764cc72&scoped=true&"
import script from "./policy-form.vue?vue&type=script&lang=js&"
export * from "./policy-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-form.vue?vue&type=style&index=0&id=c764cc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c764cc72",
  null
  
)

export default component.exports